import React, { useState } from 'react';

import { FormikValues } from 'formik';

import { FORM_VALUE_ENUM } from './constant';

import { GridElem } from '../../common/grid';
import { FieldTextElem } from '../../common/field-text';
import { ButtonElem } from '../../common/button';
import { LoaderElem } from '../../common/loader';
import { AlertActionElem } from '../../common/alert-action';
import { FormElem } from '../../common/form';
import { i18n } from '../../lib/lang';

import { TextElem } from '../../common/text';
import { DoubleContainerElem } from '../../common/double-container';
import styled from 'styled-components';
import { Spacing } from '../../theme';
import { ContentContainerElem } from '../../common/content-container';
import addIcon from '../../asset/svg/button/plus.svg';
import { COLOR_ENUM } from '../../theme/color';
import {
  SIZE_BORDER_RADIUS_DATA,
  SIZE_BORDER_RADIUS_ENUM,
} from '../../theme/size';

import { ReactComponent as AddIconLarge } from '../../asset/svg/common/add.svg';
import { ReactComponent as CloseIcon } from '../../asset/svg/common/close.svg';
import { FieldTextAreaElem } from '../../common/field-text-area';
import { FieldNumberElem } from '../../common/field-number';
import { SelectPreloadContainer } from '../select-preload';
import { convertUserListToSelect } from '../../data/user/convert';
import { getAllUserList } from '../../data/user/action';

export const Component: React.FC<{
  formik: FormikValues;
  isFieldError: Function;
  getFieldError: Function;
  isSubmitDisabled: Function;
  getFieldValue: Function;
  isLoading?: boolean;
  isSuccess?: boolean;
  isError?: boolean;
  errorMessage?: string;
  formVisible: boolean;
  setFormVisible: Function;
  setFieldValue: Function;
}> = ({
  formik,
  isFieldError,
  getFieldError,
  isSubmitDisabled,
  getFieldValue,
  isLoading,
  isSuccess,
  isError,
  errorMessage,
  formVisible,
  setFormVisible,
  setFieldValue,
}) => {
  const closeModal = () => {
    formik.resetForm();

    setFormVisible(false);
  };
  return (
    <>
      {formVisible ? (
        <FormElem onSubmit={formik.handleSubmit}>
          {isLoading && <LoaderElem />}
          <ContentContainerElem>
            <GridElem spacing={5}>
              <TitleContainer>
                <TextElem
                  tid="PROJECT.CREATE.TITLE"
                  type="semi-bold"
                  size="main"
                />
                <CloseIcon onClick={closeModal} style={{ cursor: 'pointer' }} />
              </TitleContainer>
              <DoubleContainerElem>
                <FieldTextElem
                  name={FORM_VALUE_ENUM.NAME}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  title="PROJECT.FORM.NAME"
                  value={getFieldValue(FORM_VALUE_ENUM.NAME)}
                  errorMessage={getFieldError(FORM_VALUE_ENUM.NAME)}
                  error={isFieldError(FORM_VALUE_ENUM.NAME)}
                />

                <FieldNumberElem
                  name={FORM_VALUE_ENUM.BUDGET}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  title="PROJECT.FORM.BUDGET"
                  value={getFieldValue(FORM_VALUE_ENUM.BUDGET)}
                  errorMessage={getFieldError(FORM_VALUE_ENUM.BUDGET)}
                  error={isFieldError(FORM_VALUE_ENUM.BUDGET)}
                />
              </DoubleContainerElem>
              <DoubleContainerElem style={{ alignItems: 'end' }}>
                <SelectPreloadContainer
                  name={FORM_VALUE_ENUM.RESPONSIBLE}
                  action={getAllUserList}
                  convert={convertUserListToSelect}
                  formik={formik}
                  title="EXPENDITURE.FORM.RESPONSIBLE.TITLE"
                  onChange={setFieldValue}
                  errorMessage={getFieldError(FORM_VALUE_ENUM.RESPONSIBLE)}
                  error={isFieldError(FORM_VALUE_ENUM.RESPONSIBLE)}
                  value={getFieldValue(FORM_VALUE_ENUM.RESPONSIBLE)}
                  dynamic
                  placeholder="EXPENDITURE.FORM.RESPONSIBLE.PLACEHOLDER"
                />
                <ButtonStyled
                  type="submit"
                  tid="PROJECT.CREATE.BUTTON"
                  fill="solid"
                  disabled={isSubmitDisabled()}
                  iconRight={addIcon}
                  onClick={formik.handleSubmit}
                />
              </DoubleContainerElem>

              {isError && <AlertActionElem text={i18n.t(`${errorMessage}`)} />}
            </GridElem>
          </ContentContainerElem>
        </FormElem>
      ) : (
        <AddContainer onClick={() => setFormVisible(true)}>
          <TextElem tid="PROJECT.CREATE.ADD" type="semi-bold" size="main" />
          <AddIconLarge />
        </AddContainer>
      )}
    </>
  );
};

const ButtonStyled = styled(ButtonElem)``;

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AddContainer = styled(TitleContainer)`
  padding: ${Spacing(4)} ${Spacing(5)};
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme[COLOR_ENUM.BORDER]};
  border-radius: ${SIZE_BORDER_RADIUS_DATA[SIZE_BORDER_RADIUS_ENUM.CARD]}px;
  transition: all 0.2s;
  :hover {
    background-color: ${({ theme }) => theme[COLOR_ENUM.BACKGROUND_THIRD]};
  }
`;
